module.exports = __webpack_public_path__ + "static/img/joinus_bg2.ca66910.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joinus/joinus_bg2.png
// module id = Nwrk
// module chunks = 1